export default __webpack_public_path__ + "static/media/Belkin.06d2f49d.svg";